// Capture before auth.ts evaluates ordinary callback handling. The capability is memory-only.
const location = new URL(window.location.href);
const supplied =
  location.pathname === '/login'
    ? new URLSearchParams(location.hash.slice(1)).get('admin_setup')
    : null;
export const adminSetupCapability =
  supplied && /^[A-Za-z0-9_-]{43}$/.test(supplied) ? supplied : null;
if (supplied) {
  history.replaceState(null, '', location.pathname + location.search);
  for (const key of [
    'sqi-password-setup-pending',
    'sqi-password-setup-user',
    'sqi-password-setup-operation',
  ])
    sessionStorage.removeItem(key);
}
